/**
 * 照片修复应用 · API 客户端（自平台 services/api.ts 拆出，随应用独立演进）
 */
import { platformFetch } from '../../platform/http';
import type { GenerateResponse } from '../../services/api';

export interface PhotoRestorePreset {
  id: string;
  label: string;
  description: string;
}

export const photoRestoreAPI = {
  async generate(request: {    presetId: string;
    quality: string;
    referenceImage: string;
    model?: string;
  }): Promise<GenerateResponse> {
    const response = await platformFetch('/photo-restore/generations', {
      method: 'POST',
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => null);
      throw new Error(error?.error || '修复任务创建失败');
    }

    return response.json();
  },

  async getPresets(): Promise<{ data: PhotoRestorePreset[] }> {
    const response = await platformFetch('/photo-restore/presets');
    if (!response.ok) throw new Error('获取修复预设失败');
    return response.json();
  },

};
